module.exports = __webpack_public_path__ + "img/winerackdog36.936afe6f.jpg";